import { v4 as uuid } from 'uuid';
import { OOVenue } from './oo-venue';
import { OrderPayment } from './order';

export class CheckDto {
	employeeId: number;
	venueKey: number;
	checkKey: string;
	checkNumber: number;
	table: string;
	created: string;
	timestamp: string;
	timeOpened: string;
	businessDate: string;
	orderType: number;
	orderTypeName: string;
	subtotal: number;
	taxtotal: number;
	discountTotal: number;
	orderTypeChargeTotal: number;
	gratuityTotal: number;
	creditCardPassAlongFee?: number;
	total: number;
	remainingBalance: number;
	owner: string;
	open: boolean;
	used: boolean;
	remnumbered: boolean;
	futureOrder: boolean;
	dueDateTime: string;
	queueDateTime: string;
	futureOrderTime: string;
	seats: CheckSeatDto[];
	numberOfGuests: number;
	revenueCenter: string;
	customerKey: string;
	firstName: string;
	lastName: string;
	phone: string;
	email: string;
	address: string;
	address2: string;
	city: string;
	state: string;
	zip: string;
	deliveryDirections: string;
	smsmessage: string;
	source: string;
	licenseKey: string;
	linkKey: string;
	status: number;
	receiptUrl: string;
	receiptToken: string;
	loyaltyAccount: string;
	pos: boolean;
	updated: string;

	venue?: OOVenue;

	public constructor(init?: Partial<CheckDto>) {
		Object.assign(this, init);
		for (var prop in this) {
			if (this[prop] === null || this[prop] === undefined) {
				delete this[prop];
			}
		}
	}
}

export class CheckSeatDto {
	seatKey: number;
	subtotal?: number;
	taxtotal?: number;
	discountTotal?: number;
	orderTypeChargeTotal?: number;
	gratuityTotal?: number;
	creditCardPassAlongFee?: number;
	total?: number;
	remainingBalance?: number;
	open?: boolean;
	used?: boolean;
	position?: number;
	items?: CheckItemDto[];
	payments?: CheckPaymentDto[];
	discounts?: CheckDiscountDto[];
	transactions?: CheckTransactionDto[];
	tabToken: string;
	tabTipPercent: number;

	public constructor(init?: Partial<CheckSeatDto>) {
		Object.assign(this, init);
		for (var prop in this) {
			if (this[prop] === null || this[prop] === undefined) {
				delete this[prop];
			}
		}
	}
}

export class CheckItemDto {
	itemKey: number;
	menuItemKey: number;
	name: string;
	quantity: number;
	price: number;
	position: number;
	priceNumber: number;
	priceNumberName: string;
	prepModCommand: number;
	courseId: number;
	positionId: number;
	void: boolean;
	hold: boolean;
	kitchenComment: boolean;
	discounted: boolean;
	discountAmount: number;
	discountAmountOrderType: number;
	discountInternalId: string;
	sub: boolean;
	extra: boolean;
	no: boolean;
	modifiers: CheckItemDto[];
	level: number;
	menuItemId: string;
	taxable: boolean;
	uuid: string;

	public constructor(init?: Partial<CheckItemDto>) {
		Object.assign(this, init);
		for (var prop in this) {
			if (this[prop] === null || this[prop] === undefined) {
				delete this[prop];
			}
		}
	}
}

export class CheckTransactionDto {
	transactionKey: string;
	amount: number;
	tip: number;
	type: number;
	displayName: string;
	account: string;
	transId: string;
	authCode: string;
	source: CheckTransactionSources;
	licenseKey: string;
	ccProcessor: number;
	created: string;
	focusPayDatacap: boolean = false;

	public constructor(init?: Partial<CheckTransactionDto>) {
		Object.assign(this, init);
		for (var prop in this) {
			if (this[prop] === null || this[prop] === undefined) {
				delete this[prop];
			}
		}
	}
}

export class CheckPaymentDto {
	paymentKey: string;
	amount: number;
	tip: number;
	tipPercent: number;
	name: string;
	account: string;
	type: CheckPaymentTypes;
	paymentName: string;
	paymentType: string;
	token: string;
	invoiceNumber: string;
	focusLinkCredit: boolean;
	source: string;
	status: number;
	licenseKey: string;
	authorization: string;
	firstName: string;
	lastName: string;
	address1: string;
	city: string;
	state: string;
	postalCode: string;
	giftBalance: number;
	pspReference: string;

	public constructor(init?: Partial<CheckPaymentDto>) {
		Object.assign(this, init);
		for (var prop in this) {
			if (this[prop] === null || this[prop] === undefined) {
				delete this[prop];
			}
		}
	}

	static fromOrderPayment(orderPayment: OrderPayment, source?: string): CheckPaymentDto {
		return new CheckPaymentDto({
			amount: orderPayment.amount,
			tip: orderPayment.tip,
			token: orderPayment.token,
			type: CheckPaymentTypes.CreditCard,
			invoiceNumber: orderPayment.invoiceNumber?.toString(),
			paymentKey: orderPayment.paymentKey || uuid(),
			source: source || 'focus-mobilepay',
			status: 0,
			paymentName: 'FocusPay',
			paymentType: 'FocusLink',
			authorization: orderPayment.authorization,
			pspReference: orderPayment.pspReference,
			account: orderPayment.displayName || orderPayment.displayNumber || undefined,
		});
	}
}

export class CheckDiscountDto {
	discountKey: number;
	id: number;
	internalId: number;
	amount: number;
	discountAmount: number;
	discountRate: number;
	itemKeys: number[];

	public constructor(init?: Partial<CheckDiscountDto>) {
		Object.assign(this, init);
		for (var prop in this) {
			if (this[prop] === null || this[prop] === undefined) {
				delete this[prop];
			}
		}
	}
}

export enum CheckPaymentTypes {
	CreditCard = 1,
	Cash = 2,
	GiftCard = 3,
	Loyalty = 4,
}

export enum CheckTransactionSources {
	POS = 0,
	FOCUSLINK = 1,
}
